import { useEffect, useState, useRef } from "react"
import { getCompany ,getAmbulanceCoverage } from "../../../Http/Index";

interface Company {
    _id: string;
    companyName: string;
}

const useViewAmbulance = () => {
    const [companys, setCompanies] = useState<Company[]>([]);
    const [selectedCompany, setSelectedCompany] = useState<string>("");
    const [ambulanceCoverageData, setAmbulanceCoverageData] = useState<any>([]);
    const [page, setPage] = useState<number>(1);
    const [limit, setLimit] = useState<number>(100);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const isFirstRender = useRef(true);
    
    useEffect(() => {  
        const fetchCompanies = async () => {        
            try {
                const response = await getCompany(); 
                const data = response.data; 
                setCompanies(data.data); 
            }
            catch (error) {
                console.error("Error fetching companies:", error);
            }
        }
        fetchCompanies();
    }, []);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        handleSubmit();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, limit]);

    const handleSubmit  = async() => {
        try{
            if(!selectedCompany){   
                alert("Please select a company");
                return;
            }
            setIsLoading(true);
            const coverageResponse = await getAmbulanceCoverage(String(selectedCompany),page,limit);
            setAmbulanceCoverageData(coverageResponse.data);
            
        }catch(error){
            console.error("Error in viewing ambulance coverage:", error);
        } finally {
            setIsLoading(false);
        }
    }   
    const handlePreviousPage = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    };

    const handleNextPage = () => {
        const totalPages = ambulanceCoverageData?.totalPages || 1;
        if (page < totalPages) {
            setPage(page + 1);
        }
    };

    const handleLimitChange = (newLimit: number) => {
        setLimit(newLimit);
        setPage(1); 
    };


    return {
        companys,
        selectedCompany,
        setSelectedCompany,
        handleSubmit,
        ambulanceCoverageData,
        page,
        setPage,
        limit,
        setLimit,
        handleLimitChange,
        handlePreviousPage,
        handleNextPage,
        isLoading
    }
}

export default useViewAmbulance;